import { THasRegInStorage, TRegInStorage } from '../types';

export const getModiefiedRegistrations = (registrationsInStorage: THasRegInStorage[]) => {
  const modifiedRegInStorage: TRegInStorage[] = registrationsInStorage?.map((reg) => {
    if (reg['business-Name']) {
      return {
        businessNameOptions: [
          reg['business-Name']?.firstbusinessName,
          reg['business-Name']?.secondbusinessName,
          reg['business-Name']?.threebusinessName,
          reg['business-Name']?.fourthbusinessName,
        ],
        title: reg['business-Name'].title,
        businessSegment: reg['business-Name']?.businessSegment,
        status: 'IN PROGRESS',
        businessNature: reg['business-Name']?.businessNature,
        businessDesc: reg['business-Name']?.businessDesc,
        createdAt: reg['business-Name']?.createdAt
          ? new Date(Number(reg['business-Name']?.createdAt))?.toISOString()
          : new Date()?.toISOString(),
        packageId: reg['business-Name']?.packageId,
        type: 'TRegInStorage',
        link: `/my-business/business-registration?step=1&id=${reg['business-Name']?.packageId}&name=${reg['business-Name'].title}`,
      };
    } else if (reg['ltd-1million']) {
      return {
        businessNameOptions: [
          reg['ltd-1million']?.firstbusinessName,
          reg['ltd-1million']?.secondbusinessName,
          reg['ltd-1million']?.threebusinessName,
          reg['ltd-1million']?.fourthbusinessName,
        ],
        businessSegment: reg['ltd-1million']?.businessSegment,
        title: reg['ltd-1million']?.title,
        status: 'IN PROGRESS',
        businessNature: reg['ltd-1million']?.businessNature,
        businessDesc: reg['ltd-1million']?.businessDesc,
        createdAt: reg['ltd-1million']?.createdAt
          ? new Date(Number(reg['ltd-1million']?.createdAt))?.toISOString()
          : new Date()?.toISOString(),
        packageId: reg['ltd-1million']?.packageId,
        type: 'TRegInStorage',
        link: `/my-business/limited-liability?step=1&id=${reg['ltd-1million']?.packageId}&name=${reg['ltd-1million']?.title}`,
      };
    } else {
      return {
        businessNameOptions: [
          reg['incorporated-trustee']?.firstbusinessName,
          reg['incorporated-trustee']?.secondbusinessName,
          reg['incorporated-trustee']?.threebusinessName,
          reg['incorporated-trustee']?.fourthbusinessName,
        ],
        businessSegment: reg['incorporated-trustee']?.businessSegment,
        title: reg['incorporated-trustee']?.title,
        status: 'IN PROGRESS',
        businessNature: reg['incorporated-trustee']?.businessNature,
        businessDesc: reg['incorporated-trustee']?.businessDesc,
        createdAt: reg['incorporated-trustee']?.createdAt
          ? new Date(Number(reg['incorporated-trustee']?.createdAt))?.toISOString()
          : new Date()?.toISOString(),
        packageId: reg['incorporated-trustee']?.packageId,
        type: 'TRegInStorage',
        link: `/my-business/incorporated-trustee?step=1&id=${reg['incorporated-trustee']?.packageId}&name=${reg['incorporated-trustee']?.title}`,
      };
    }
  });
  return modifiedRegInStorage;
};
